import PurchaseOrderService from '../../api/purchaseOrder';
// import Cookies from 'js-cookie';

const state = {};

const getters = {};

const actions = {
	async getSupplierProducts({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await PurchaseOrderService.getSupplierProductsAsync(
			authToken,
			request_data
		);
		return response;
	},

	async generatePurchaseOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data['clientId'] = agentProfile.clientId;
		const response = await PurchaseOrderService.generatePurchaseOrderAsync(
			authToken,
			request_data
		);
		return response;
	},

	async getGeneratedPurchaseOrders({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data.searchBy['clientId'] = agentProfile.clientId;
		const response = await PurchaseOrderService.getGeneratedPurchaseOrdersAsync(
			authToken,
			request_data
		);
		return response;
	},

	async updateGeneratedPurchaseOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data.data['clientId'] = agentProfile.clientId;
		const response = await PurchaseOrderService.updateGeneratedPurchaseOrderAsync(
			authToken,
			request_data
		);
		return response;
	},

	async updatePurchaseOrderStatus({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await PurchaseOrderService.updatePurchaseOrderStatusAsync(
			authToken,
			request_data
		);
		return response;
	},

	async getReplenishOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data['clientId'] = agentProfile.clientId;
		const response = await PurchaseOrderService.getReplenishOrderAsync(
			authToken,
			request_data
		);
		return response;
	},

	async getBackOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data['clientId'] = agentProfile.clientId;
		const response = await PurchaseOrderService.getBackOrderAsync(
			authToken,
			request_data
		);
		return response;
	},

	async confirmProductLnes({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await PurchaseOrderService.confirmProductLnesAsync(
			authToken,
			request_data
		);
		return response;
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
